import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { components } from "react-select";
import AdornmentWrapper from "../../../TextInput/components/AdornmentWrapper";
import { BaseIsMultiWrapper } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function CustomControl(innerProps) {
  var BaseControl = components.Control;
  var children = innerProps.children,
    selectProps = innerProps.selectProps,
    isMulti = innerProps.isMulti,
    hasValue = innerProps.hasValue;
  var icon = selectProps.icon;
  var renderAdornment = function renderAdornment() {
    return /*#__PURE__*/_jsx(AdornmentWrapper, {
      side: "start",
      adornmentProps: {
        type: "icon",
        props: {
          icon: icon
        }
      }
    });
  };
  return /*#__PURE__*/_jsxs(BaseControl, _extends({}, innerProps, {
    children: [icon && (isMulti && hasValue ? /*#__PURE__*/_jsx(BaseIsMultiWrapper, {
      children: renderAdornment()
    }) : renderAdornment()), children]
  }));
}
CustomControl.displayName = "CustomControl";
export default CustomControl;